import { render, staticRenderFns } from "./NewGradeButton.vue?vue&type=template&id=48f1ac59&scoped=true&"
import script from "./NewGradeButton.vue?vue&type=script&lang=ts&"
export * from "./NewGradeButton.vue?vue&type=script&lang=ts&"
import style0 from "./NewGradeButton.vue?vue&type=style&index=0&id=48f1ac59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f1ac59",
  null
  
)

export default component.exports